export default function generateAnimationName(id) {
  return 'k' + id;
}